import axios from 'axios';

import type {
  IUserGetUserDefaultContactsQuery,
  IUserGetUserDefaultContactsRequest,
  IUserGetUserDefaultContactsResponse,
} from '@/app-package';

const getUserDefaultContacts = async (
  params: IUserGetUserDefaultContactsQuery,
) => {
  const config: IUserGetUserDefaultContactsRequest = {
    url: '/user/default/contacts',
    method: 'get',
    params,
  };

  const { data } =
    await axios.request<IUserGetUserDefaultContactsResponse>(config);

  return data;
};

export default getUserDefaultContacts;
